<div [hidden]="!active" class="pane">
  <ng-content></ng-content>
  <ng-container
    *ngIf="template"
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{ person: dataContext }"
  >
  </ng-container>
</div>
